"use strict";
var _a, _IsomorphicClerk_loaded, _IsomorphicClerk_instance;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const errors_1 = require("./errors");
const utils_1 = require("./utils");
class IsomorphicClerk {
    constructor(params) {
        this.clerkjs = null;
        this.preopenSignIn = null;
        this.preopenSignUp = null;
        this.preopenUserProfile = null;
        this.premountSignInNodes = new Map();
        this.premountSignUpNodes = new Map();
        this.premountUserProfileNodes = new Map();
        this.premountUserButtonNodes = new Map();
        this.premountMethodCalls = new Map();
        this.loadedListeners = [];
        _IsomorphicClerk_loaded.set(this, false);
        this.addOnLoaded = (cb) => {
            this.loadedListeners.push(cb);
        };
        this.emitLoaded = () => {
            this.loadedListeners.forEach(cb => cb());
            this.loadedListeners = [];
        };
        this.hydrateClerkJS = async (clerkjs) => {
            if (!clerkjs) {
                throw new Error('Failed to hydrate latest Clerk JS');
            }
            this.clerkjs = clerkjs;
            this.premountMethodCalls.forEach(cb => cb());
            if (this.preopenSignIn !== null) {
                clerkjs.openSignIn(this.preopenSignIn);
            }
            if (this.preopenSignUp !== null) {
                clerkjs.openSignUp(this.preopenSignUp);
            }
            if (this.preopenUserProfile !== null) {
                clerkjs.openUserProfile(this.preopenUserProfile);
            }
            this.premountSignInNodes.forEach((props, node) => {
                clerkjs.mountSignIn(node, props);
            });
            this.premountSignUpNodes.forEach((props, node) => {
                clerkjs.mountSignUp(node, props);
            });
            this.premountUserProfileNodes.forEach((props, node) => {
                clerkjs.mountUserProfile(node, props);
            });
            this.premountUserButtonNodes.forEach((props, node) => {
                clerkjs.mountUserButton(node, props);
            });
            tslib_1.__classPrivateFieldSet(this, _IsomorphicClerk_loaded, true, "f");
            this.emitLoaded();
            return this.clerkjs;
        };
        this.__unstable__updateProps = (props) => {
            // Handle case where accounts has clerk-react@4 installed, but clerk-js@3 is manually loaded
            if (this.clerkjs && '__unstable__updateProps' in this.clerkjs) {
                this.clerkjs.__unstable__updateProps(props);
            }
            else {
                return undefined;
            }
        };
        /**
         * `setActive` can be used to set the active session and/or organization.
         * It will eventually replace `setSession`.
         *
         * @experimental
         */
        this.setActive = ({ session, organization, beforeEmit }) => {
            if (this.clerkjs) {
                return this.clerkjs.setActive({ session, organization, beforeEmit });
            }
            else {
                return Promise.reject();
            }
        };
        this.setSession = (session, beforeEmit) => {
            return this.setActive({ session, beforeEmit });
        };
        this.openSignIn = (props) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.openSignIn(props);
            }
            else {
                this.preopenSignIn = props;
            }
        };
        this.closeSignIn = () => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.closeSignIn();
            }
            else {
                this.preopenSignIn = null;
            }
        };
        this.openUserProfile = (props) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.openUserProfile(props);
            }
            else {
                this.preopenUserProfile = props;
            }
        };
        this.closeUserProfile = () => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.closeUserProfile();
            }
            else {
                this.preopenUserProfile = null;
            }
        };
        this.openSignUp = (props) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.openSignUp(props);
            }
            else {
                this.preopenSignUp = props;
            }
        };
        this.closeSignUp = () => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.closeSignUp();
            }
            else {
                this.preopenSignUp = null;
            }
        };
        this.mountSignIn = (node, props) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.mountSignIn(node, props);
            }
            else {
                this.premountSignInNodes.set(node, props);
            }
        };
        this.unmountSignIn = (node) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.unmountSignIn(node);
            }
            else {
                this.premountSignInNodes.delete(node);
            }
        };
        this.mountSignUp = (node, props) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.mountSignUp(node, props);
            }
            else {
                this.premountSignUpNodes.set(node, props);
            }
        };
        this.unmountSignUp = (node) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.unmountSignUp(node);
            }
            else {
                this.premountSignUpNodes.delete(node);
            }
        };
        this.mountUserProfile = (node, props) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.mountUserProfile(node, props);
            }
            else {
                this.premountUserProfileNodes.set(node, props);
            }
        };
        this.unmountUserProfile = (node) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.unmountUserProfile(node);
            }
            else {
                this.premountUserProfileNodes.delete(node);
            }
        };
        this.mountUserButton = (node, userButtonProps) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.mountUserButton(node, userButtonProps);
            }
            else {
                this.premountUserButtonNodes.set(node, userButtonProps);
            }
        };
        this.unmountUserButton = (node) => {
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                this.clerkjs.unmountUserButton(node);
            }
            else {
                this.premountUserButtonNodes.delete(node);
            }
        };
        this.addListener = (listener) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.addListener(listener); };
            if (this.clerkjs) {
                callback();
            }
            else {
                this.premountMethodCalls.set('addListener', callback);
            }
        };
        this.navigate = (to) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.navigate(to); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                void callback();
            }
            else {
                this.premountMethodCalls.set('navigate', callback);
            }
        };
        this.redirectToSignIn = (opts) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToSignIn(opts); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                void callback();
            }
            else {
                this.premountMethodCalls.set('redirectToSignIn', callback);
            }
        };
        this.redirectToSignUp = (opts) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToSignUp(opts); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                void callback();
            }
            else {
                this.premountMethodCalls.set('redirectToSignUp', callback);
            }
        };
        this.redirectToUserProfile = () => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.redirectToUserProfile(); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                callback();
            }
            else {
                this.premountMethodCalls.set('redirectToUserProfile', callback);
            }
        };
        this.handleRedirectCallback = (params) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.handleRedirectCallback(params); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                void callback();
            }
            else {
                this.premountMethodCalls.set('handleRedirectCallback', callback);
            }
        };
        this.handleMagicLinkVerification = async (params) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.handleMagicLinkVerification(params); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                return callback();
            }
            else {
                this.premountMethodCalls.set('handleMagicLinkVerification', callback);
            }
        };
        this.authenticateWithMetamask = async (params) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.authenticateWithMetamask(params); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                return callback();
            }
            else {
                this.premountMethodCalls.set('authenticateWithMetamask', callback);
            }
        };
        this.createOrganization = async (params) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.createOrganization(params); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                return callback();
            }
            else {
                this.premountMethodCalls.set('createOrganization', callback);
            }
        };
        this.getOrganizationMemberships = async () => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.getOrganizationMemberships(); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                return callback();
            }
            else {
                this.premountMethodCalls.set('getOrganizationMemberships', callback);
            }
        };
        this.getOrganization = async (organizationId) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.getOrganization(organizationId); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                return callback();
            }
            else {
                this.premountMethodCalls.set('getOrganization', callback);
            }
        };
        this.signOut = async (signOutCallbackOrOptions, options) => {
            const callback = () => { var _b; return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.signOut(signOutCallbackOrOptions, options); };
            if (this.clerkjs && tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
                return callback();
            }
            else {
                this.premountMethodCalls.set('signOut', callback);
            }
        };
        const { Clerk = null, frontendApi, options = {} } = params || {};
        this.frontendApi = frontendApi;
        this.options = options;
        this.Clerk = Clerk;
        this.mode = (0, utils_1.inClientSide)() ? 'browser' : 'server';
        void this.loadClerkJS();
    }
    get loaded() {
        return tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f");
    }
    static getOrCreateInstance(params) {
        // During SSR: a new instance should be created for every request
        // During CSR: use the cached instance for the whole lifetime of the app
        // This method should be idempotent in both scenarios
        if (!(0, utils_1.inClientSide)() || !tslib_1.__classPrivateFieldGet(this, _a, "f", _IsomorphicClerk_instance)) {
            tslib_1.__classPrivateFieldSet(this, _a, new IsomorphicClerk(params), "f", _IsomorphicClerk_instance);
        }
        return tslib_1.__classPrivateFieldGet(this, _a, "f", _IsomorphicClerk_instance);
    }
    async loadClerkJS() {
        if (this.mode !== 'browser' || tslib_1.__classPrivateFieldGet(this, _IsomorphicClerk_loaded, "f")) {
            return;
        }
        if (!this.frontendApi) {
            this.throwError(errors_1.noFrontendApiError);
        }
        try {
            if (this.Clerk) {
                // Set a fixed Clerk version
                let c;
                if ((0, utils_1.isConstructor)(this.Clerk)) {
                    // Construct a new Clerk object if a constructor is passed
                    c = new this.Clerk(this.frontendApi);
                    await c.load(this.options);
                }
                else {
                    // Otherwise use the instantiated Clerk object
                    c = this.Clerk;
                    if (!c.isReady()) {
                        await c.load(this.options);
                    }
                }
                global.Clerk = c;
            }
            else {
                // Hot-load latest ClerkJS from Clerk CDN
                await (0, utils_1.loadScript)({
                    frontendApi: this.frontendApi,
                    scriptUrl: this.options.clerkJSUrl,
                    scriptVariant: this.options.clerkJSVariant,
                });
                if (!global.Clerk) {
                    throw new Error('Failed to download latest ClerkJS. Contact support@clerk.dev.');
                }
                await global.Clerk.load(this.options);
            }
            return this.hydrateClerkJS(global.Clerk);
        }
        catch (err) {
            let message;
            if (err instanceof Error) {
                message = err.message;
            }
            else {
                message = String(err);
            }
            this.throwError(message);
            return;
        }
    }
    // Custom wrapper to throw an error, since we need to apply different handling between
    // production and development builds. In Next.js we can throw a full screen error in
    // development mode. However, in production throwing an error results in an infinite loop
    // as shown at https://github.com/vercel/next.js/issues/6973
    throwError(errorMsg) {
        if (process.env.NODE_ENV === 'production') {
            console.error(errorMsg);
        }
        throw new Error(errorMsg);
    }
    get version() {
        var _b;
        return (_b = this.clerkjs) === null || _b === void 0 ? void 0 : _b.version;
    }
    get client() {
        if (this.clerkjs) {
            return this.clerkjs.client;
            // TODO: add ssr condition
        }
        else {
            return undefined;
        }
    }
    get session() {
        if (this.clerkjs) {
            return this.clerkjs.session;
            // TODO: add ssr condition
        }
        else {
            return undefined;
        }
    }
    get user() {
        if (this.clerkjs) {
            return this.clerkjs.user;
        }
        else {
            return undefined;
        }
    }
    get organization() {
        if (this.clerkjs) {
            return this.clerkjs.organization;
        }
        else {
            return undefined;
        }
    }
    // TODO: Remove temp use of __unstable__environment
    get __unstable__environment() {
        if (this.clerkjs) {
            return this.clerkjs.__unstable__environment;
            // TODO: add ssr condition
        }
        else {
            return undefined;
        }
    }
}
exports.default = IsomorphicClerk;
_a = IsomorphicClerk, _IsomorphicClerk_loaded = new WeakMap();
_IsomorphicClerk_instance = { value: void 0 };
